import React, { Component } from "react";
import {
  Card,
  Badge,
  ButtonDropdown,
  CustomInput,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { connect } from "react-redux";
import {
  setContainerClassnames,
  clickOnMobileMenu,
} from "../../../redux/actions";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import { Separator } from "../../../components/common/CustomBootstrap";

class LabelItemLeft extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownSplitOpen: false,
    };
  }

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems,
    );
  };

  onClickedItem = (item) => {
    this.props.onClickedItem(
      // callback
      item,
      this.menuButtonClick,
      [null, 1000, this.props.containerClassnames],
    );
  };

  getRoleBadgeColor = (roleName) => {
    if (!roleName) return "warning";
    const name = roleName.toLowerCase();
    if (name.includes("thu ngân") || name.includes("cashier"))
      return "secondary";
    if (name.includes("bếp") || name.includes("kitchen")) return "success";
    if (
      name.includes("chạy bàn") ||
      name.includes("payment") ||
      name.includes("thanh toán")
    )
      return "info";
    return "primary";
  };

  render() {
    const { dropdownSplitOpen } = this.state;
    const { item } = this.props;
    const roleName = item.user_role_id
      ? item.user_role_id.label || item.user_role_id.name
      : null;

    return (
      <Card className="mb-3 custom-shadow">
        <div className="d-flex flex-row cursor-pointer">
          <div className={"d-flex flex-grow-1 min-width-zero"}>
            <div
              onClick={() => this.onClickedItem(item)}
              className="card-body w-100 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center"
            >
              <div className="list-item-heading mb-1 truncate d-block w-40 w-sm-100">
                <span>{item.name}</span>
              </div>
              <div className="text-center w-20 w-sm-100 mb-1 mb-lg-0">
                {roleName ? (
                  <Badge color={this.getRoleBadgeColor(roleName)} pill>
                    {roleName}
                  </Badge>
                ) : (
                  <Badge color="warning" pill>
                    Chưa phân quyền
                  </Badge>
                )}
              </div>
              {item.username && (
                <div className="text-muted w-30 w-sm-100 text-small">
                  @{item.username}
                </div>
              )}
            </div>
            {/* Simple Checkbox - for multi-select */}
            <div
              className="custom-control custom-checkbox align-self-center"
              style={{
                padding: "15px 20px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                this.props.onChangeCheckbox(item.id, e);
              }}
            >
              <CustomInput
                type="checkbox"
                id={`check-user-role-${item.id}`}
                label=""
                checked={this.props.selectedItems.includes(item.id)}
                onChange={() => {}}
              />
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
export default connect(mapStateToProps, {
  setContainerClassnames,
  clickOnMobileMenu,
})(LabelItemLeft);
